/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AuthorityType } from './authority-type';


export interface EsercenteBackofficeRowDTO { 
    id?: string;
    email?: string;
    nome?: string;
    cognome?: string;
    ragione_sociale?: string;
    partita_iva?: string;
    stato?: EsercenteBackofficeRowDTOStatoEnum;
    ruoli?: Set<AuthorityType>;
}
export enum EsercenteBackofficeRowDTOStatoEnum {
    BLOCCATO_DA_BACKOFFICE = 'BLOCCATO_DA_BACKOFFICE',
    EMAIL_NON_VERIFICATA = 'EMAIL_NON_VERIFICATA',
    IN_ATTESA_DI_ATTIVAZIONE = 'IN_ATTESA_DI_ATTIVAZIONE',
    ATTIVO = 'ATTIVO'
};



